import { atomWithKey as atom } from "./atomWithKey";
import { ILoyaltyProgramResponse } from "../Types/Interface/ILoyaltyProgram";
import { ILoyaltyTier } from "../../Orchestrator/Types/Interface/ICustomerTiers";
import { IAboutLoyaltyProgramResponse } from "../Types/Interface/ICmsAboutLoyaltyProgram";

export const loyaltyProgramDataAtom = atom<ILoyaltyProgramResponse | null>({
  key: "loyaltyProgramDataAtom",
  default: null,
});

export const customerTiersDataAtom = atom<ILoyaltyTier | null>({
  key: "customerTiersDataAtom",
  default: null,
});

export const cmsAboutLoyaltyProgramResponseAtom =
  atom<IAboutLoyaltyProgramResponse | null>({
    key: "cmsAboutLoyaltyProgramResponseAtom",
    default: null,
  });

export const loyaltyCardHandleSelectActionAtom = atom<boolean>({
  key: "loyaltyCardHandleSelectActionAtom",
  default: false,
});
